import { log } from './general';
/* istanbul ignore file */
export class AbortControllerStub {
    abort() {
        log('Stub', 'Aborted');
    }
}
